module.exports = __webpack_public_path__ + "img/CO.43da0f63.png";